import type { DocumentType } from '../graphql/generated';
import { gql } from '../graphql/generated';

const IS_VERIFIER_POST_FRAGMENT = gql(`
  fragment isVerifier_post on Post {
    id
    verification {
      id
      primaryVerifier {
        id
      }
      secondaryVerifiers {
        id
      }
    }
  }
`);

function isVerifier(
  post: DocumentType<typeof IS_VERIFIER_POST_FRAGMENT>,
  user: { id: string },
) {
  return !!(
    post.verification?.primaryVerifier.id === user.id ||
    post.verification?.secondaryVerifiers.some((v) => v?.id === user.id)
  );
}

export default isVerifier;
